import React from "react"
import Card from "../../../../containers/Card/Card"
import Chips from "../../../Chips/Chips"
import {Countries} from "../../../../resources/common"
import {chipMaxWidth} from "../../riskSettings"
import ProhibitedCountriesIcon from "../ProhibitedCountriesIcon"
import ProhibitedCountriesSubtitle from "../ProhibitedCountriesSubtitle"
import {ProhibitedCountriesType} from "../../RiskSettingsUtils"
import {CountriesFieldWithAllowUsOnlyToggleType} from "../../../CountriesFieldWithAllowUsOnlyToggle/CountriesFieldWithAllowUsOnlyToggleUtils"
import ProhibitedCountriesTitle from "../ProhibitedCountriesTitle"

function CountriesWithAllowUsOnlyToggle({
	value,
	title,
}: {
	value: CountriesFieldWithAllowUsOnlyToggleType
	title?: string
}) {
	return (
		<div className="field-container">
			{value.isAllowUsOnly ? (
				<span className="text-black">Prohibit all countries outside of the U.S.</span>
			) : (
				<>
					{title && (
						<div className="mb-4">
							<span className="text-black">{title}</span>
						</div>
					)}
					<SelectedCountries value={value.countries} />
				</>
			)}
		</div>
	)
}

function SelectedCountries({value}: {value: string[]}) {
	return value.length > 0 ? (
		<Chips maxWidth={chipMaxWidth} labels={value.map((v) => Countries[v as keyof typeof Countries])} readonly />
	) : (
		<NoCountriesSelected />
	)
}

function SelectedCountriesField({value}: {value: string[]}) {
	return (
		<div className="field-container">
			<SelectedCountries value={value} />
		</div>
	)
}

function NoCountriesSelected() {
	return <span className="no-values-selected">No countries selected</span>
}

interface ProhibitedBusinessVerticalsProps {
	value: ProhibitedCountriesType
	defaultValue?: ProhibitedCountriesType
}

export default function ProhibitedCountriesViewMode({value, defaultValue}: ProhibitedBusinessVerticalsProps) {
	return (
		<div className="risk-settings-card">
			<Card
				title="Prohibited Countries"
				subtitle={<ProhibitedCountriesSubtitle />}
				className="header-with-large-gap"
				icon={<ProhibitedCountriesIcon />}
			>
				<div className="bank-risk-prohibited-countries">
					<h2>Individual Customer</h2>
					<ProhibitedCountriesTitle
						text="Physical Address"
						value={value.individualCustomer.physicalAddress}
						defaultValue={defaultValue?.individualCustomer.physicalAddress}
					/>
					<CountriesWithAllowUsOnlyToggle value={value.individualCustomer.physicalAddress} />
					<ProhibitedCountriesTitle
						text="Citizenship"
						value={value.individualCustomer.citizenship}
						defaultValue={defaultValue?.individualCustomer.citizenship}
					/>
					<SelectedCountriesField value={value.individualCustomer.citizenship} />
					<hr className="divider" />
					<h2>Sole Proprietor Customer</h2>
					<ProhibitedCountriesTitle
						text="Physical Address"
						value={value.soleProprietorCustomer.physicalAddress}
						defaultValue={defaultValue?.soleProprietorCustomer.physicalAddress}
					/>
					<CountriesWithAllowUsOnlyToggle value={value.soleProprietorCustomer.physicalAddress} />
					<ProhibitedCountriesTitle
						text="Citizenship"
						value={value.soleProprietorCustomer.citizenship}
						defaultValue={defaultValue?.soleProprietorCustomer.citizenship}
					/>
					<SelectedCountriesField value={value.soleProprietorCustomer.citizenship} />
					<hr className="divider" />
					<h2>Business Customer</h2>
					<ProhibitedCountriesTitle
						text="Physical Address"
						value={value.businessCustomer.physicalAddress}
						defaultValue={defaultValue?.businessCustomer.physicalAddress}
					/>
					<CountriesWithAllowUsOnlyToggle value={value.businessCustomer.physicalAddress} />
					<ProhibitedCountriesTitle
						text="Countries of Operation"
						value={value.businessCustomer.countriesOfOperation}
						defaultValue={defaultValue?.businessCustomer.countriesOfOperation}
					/>
					<div className="is-us-presence-required-container view-mode-text-container">
						<span className="text-black">U.S. presence required:</span>
						<span className="font-bold text-black">
							{value.businessCustomer.countriesOfOperation.isUsPresenceRequired ? "On" : "Off"}
						</span>
					</div>
					<CountriesWithAllowUsOnlyToggle
						value={value.businessCustomer.countriesOfOperation}
						title="Prohibited countries"
					/>
					<ProhibitedCountriesTitle
						text="Beneficial Owner or Officer - Address"
						value={value.businessCustomer.beneficialOwnerOrOfficerAddress}
						defaultValue={defaultValue?.businessCustomer.beneficialOwnerOrOfficerAddress}
					/>
					<CountriesWithAllowUsOnlyToggle value={value.businessCustomer.beneficialOwnerOrOfficerAddress} />
					<ProhibitedCountriesTitle
						text="Beneficial Owner or Officer - Citizenship"
						value={value.businessCustomer.beneficialOwnerOrOfficerCitizenship}
						defaultValue={defaultValue?.businessCustomer.beneficialOwnerOrOfficerCitizenship}
					/>
					<SelectedCountriesField value={value.businessCustomer.beneficialOwnerOrOfficerCitizenship} />
				</div>
			</Card>
		</div>
	)
}
